import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-upload",
  "use": "icon-upload-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-upload\">\n<path d=\"M1.33331 11.3334L1.33331 12.1667C1.33331 13.5475 2.4526 14.6667 3.83331 14.6667L12.1666 14.6667C13.5474 14.6667 14.6666 13.5475 14.6666 12.1667L14.6666 11.3334M11.3333 4.66675L7.99998 1.33341M7.99998 1.33341L4.66665 4.66675M7.99998 1.33341L7.99998 11.3334\" stroke=\"#374151\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol